import { TimetableRelationshipProperties } from '@bp/planung-graphql-types';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useMemorizedCacheTag } from '../../../hooks/useMemorizedCacheTag';
import { useClassAvailabilityMatrixQuery } from '../../../types/planung-graphql-client-defs';
import { AvailabilityMatrix, Day, TimeGridEntry } from '../../AvailabilityMatrix/AvailabilityMatrix';
import { useTimetableStore } from '../../TimetableGrid/TimetableProvider';

type TimetableVersionClassesMatrixProps = {
  selectedUuid: string;
  versionUuid?: string | null;
  timeGridEntries: TimeGridEntry[];
  loading: boolean;
  onChange: (availability: TimetableRelationshipProperties) => void;
};

export const TimetableVersionClassesMatrix = observer(
  ({ versionUuid, selectedUuid, timeGridEntries, loading, onChange }: TimetableVersionClassesMatrixProps) => {
    const store = useTimetableStore();
    const context = useMemorizedCacheTag('CLASSES_MATRIX');

    const [{ data, fetching }, execute] = useClassAvailabilityMatrixQuery({
      variables: {
        versionUuid: versionUuid ?? '',
      },
      context: context,
    });

    const days: Day[] = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

    const hours = timeGridEntries.filter((entry) => !entry.pause);

    const availability = data?.timetableVersions[0].classesConnection.edges.find((e) => e.node.uuid === selectedUuid);

    return (
      <AvailabilityMatrix
        days={days}
        hours={hours}
        availability={availability?.properties}
        readonly={toJS(store.readonly) || fetching}
        loading={loading}
        onChange={(items) => {
          onChange(items);
          execute();
        }}
      />
    );
  },
);
